<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand navbar-dark bg-dark"
  >
    <a
      href="#"
      aria-current="page"
      class="
        h4
        mb-0
        text-white text-uppercase
        d-none d-lg-inline-block
        active
        router-link-active
      "
    >
      {{ $route.name }}
    </a>

    <b-navbar-nav class="align-items-center ml-md-auto">
      <li class="nav-item d-sm-none">
        <a
          class="nav-link"
          href="#"
          data-action="search-show"
          data-target="#navbar-search-main"
        >
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
    </b-navbar-nav>

    <b-navbar-nav class="align-items-lg-center ml-lg-auto">
      <b-nav-item
        @click="setLanguage('fr')"
        :class="[language == 'fr' ? 'language active' : 'language']"
      >
        <el-tooltip placement="bottom" :content="$t('tooltip.language.fr')">
          <span class="nav-link-inner--text">{{ $t("language.fr") }}</span>
        </el-tooltip>
      </b-nav-item>
      |
      <b-nav-item
        @click="setLanguage('en')"
        :class="[language == 'en' ? 'language active' : 'language']"
      >
        <el-tooltip placement="bottom" :content="$t('tooltip.language.en')">
          <span class="nav-link-inner--text">{{ $t("language.en") }}</span>
        </el-tooltip>
      </b-nav-item>
      |
      <b-nav-item
        @click="setLanguage('pl')"
        :class="[language == 'pl' ? 'language active' : 'language']"
      >
        <el-tooltip placement="bottom" :content="$t('tooltip.language.pl')">
          <span class="nav-link-inner--text">{{ $t("language.pl") }}</span>
        </el-tooltip>
      </b-nav-item>
    </b-navbar-nav>

    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <el-tooltip placement="bottom" :content="$t('tooltip.profile')">
                <i class="ni ni-single-02 text-white"></i>
              </el-tooltip>
            </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{ fullName }}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-item class="logout">
            <b-link @click="logout">
              <i class="icon-xs"
                ><b-img alt="..." src="./img/icons/common/logout.svg"
              /></i>
              &nbsp;
              <span class="text-dark">{{ $t("admin.logout") }}</span>
            </b-link>
          </b-dropdown-item>
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import Vue from "vue";
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import { mapActions } from "vuex";
import { PublicClientApplication } from "@azure/msal-browser";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    let user = this.$store.getters.User;
    return {
      language: Vue.i18n.locale(),
      showMenu: false,
      fullName: user.usr_firstname + " " + user.usr_lastname,
      isAuthEmailEnabled: process.env.VUE_APP_AUTH_DEMO_ENABLED === "1"
    };
  },
  async created() {
    this.$msalInstance = new PublicClientApplication(
      this.$store.state.msalConfig
    );
  },
  mounted() {
    this.setUser();
  },
  methods: {
    ...mapActions(["LogOut"]),

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    setLanguage(locale) {
      Vue.i18n.set(locale);
      this.language = locale;
      localStorage.setItem(Vue.Keys.LANGUAGE, locale);
      this.$router.go();
    },

    async logout() {
      if(this.isAuthEmailEnabled) {
        await this.$store.dispatch("LogOut");
        this.$router.push("/login");
      }else
        await this.SignOut();
    },

    async SignOut() {
      this.account = null;
      this.$store.dispatch("LogOut");
      await this.$msalInstance
        .logout({});
        // .then(() => {
        //   this.$store.dispatch("LogOut");
        // })
        // .catch(() => {
        //   this.$store.dispatch("LogOut");
        // });
    },
  },
};
</script>
